/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const s = ({
  buttonCount: e = 10,
  info: o = !0,
  type: r = "numeric",
  pageSizes: i = void 0,
  previousNext: t = !0,
  responsive: a = void 0,
  navigatable: l = void 0,
  pageSizeValue: n = void 0
}) => ({
  buttonCount: e,
  info: o,
  pageSizes: i === !0 ? [5, 10, 20] : i || void 0,
  previousNext: t,
  responsive: a !== !1,
  navigatable: l !== !1,
  type: r,
  pageSizeValue: n
}), u = (e) => s(e === !0 ? {} : e);
export {
  u as normalize
};
